import { createReducer, on } from '@ngrx/store';

import * as DepartmentsActions from '../actions/departments.actions';
import { Department } from '../../interfaces/departments.model';

export const departmentsFeatureKey = 'departments';

export interface DepartmentState {
  entities: Array<Department>;
  allDepartments: Array<Department>;
  loaded: boolean;
  loading: boolean;
  allLoaded: boolean;
  allLoading: boolean;
  total: number;
  importing: boolean;
  imported: boolean;
}

export const initialState: DepartmentState = {
  entities: [],
  allDepartments: [],
  loaded: false,
  loading: false,
  allLoaded: false,
  allLoading: false,
  total: 0,
  importing: false,
  imported: false
};

const departmentsReducer = createReducer(
  initialState,
  on(DepartmentsActions.loadDepartments, state => ({ ...state, loading: true })),
  on(DepartmentsActions.loadDepartmentsSuccess, (state, { payload }) => {
    const departments = payload;
    const total = departments.total;
    const entities = departments.results.reduce((all: { [uid: string]: Department }, item: Department) => {
      return { ...all, [item.uid]: item };
    }, {});
    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(DepartmentsActions.loadDepartmentsFail, state => ({ ...state, loading: false, loaded: false })),
  on(DepartmentsActions.loadMoreDepartments, state => ({ ...state, loading: true })),
  on(DepartmentsActions.loadMoreDepartmentsSuccess, (state, { payload }) => {
    const departments = { ...payload, results: [...payload?.results, ...Object.values(state.entities)] };
    const total = departments.total;

    const entities = departments.results.reduce((all: { [uid: string]: Department }, item: Department) => {
      return { ...all, [item.uid]: item };
    }, {});

    return { ...state, loading: false, loaded: true, entities, total };
  }),
  on(DepartmentsActions.loadMoreDepartmentsFail, state => ({ ...state, loading: false, loaded: false })),
  on(DepartmentsActions.loadAllDepartments, state => ({ ...state, AllLoading: true })),
  on(DepartmentsActions.loadAllDepartmentsSuccess, (state, { payload }) => {
    const allDepartments = payload;

    return { ...state, allLoading: false, allLoaded: true, allDepartments };
  }),
  on(DepartmentsActions.loadAllDepartmentsFail, state => ({ ...state, allLoading: false, allLoaded: false })),
  on(DepartmentsActions.searchDepartments, state => ({ ...state, loading: true })),
  on(DepartmentsActions.searchDepartmentsSuccess, (state, { payload }) => {
    const entities = payload;
    return { ...state, loading: false, loaded: true, entities };
  }),
  on(DepartmentsActions.searchDepartmentsFail, state => ({ ...state, loading: false, loaded: false }))
);

export function reducer(state, action) {
  return departmentsReducer(state, action);
}

export const getDepartmentsEntities = (state: DepartmentState) => state?.entities;
export const getDepartmentsLoading = (state: DepartmentState) => state?.loading;
export const getDepartmentsLoaded = (state: DepartmentState) => state?.loaded;
export const getTotalDepartments = (state: DepartmentState) => state?.total;

export const getAllDepartmentsEntities = (state: DepartmentState) => state?.allDepartments;
export const getAllDepartmentsLoading = (state: DepartmentState) => state?.allLoading;
export const getAllDepartmentsLoaded = (state: DepartmentState) => state?.allLoaded;
